function wishlistometria(email,_this, source) {
    var settings = {
      url: 'https://api.ometria.com/forms/signup/ajax',
      data: {
        "ue": email,
        "__form_id": "39b5dec589836a6b1d47caab5a1b6071",
        "email": "",
        "__email": "",
        "@account": "9ecb7806fdcacc69",
        "@return_url": "",
        "@subscription_status": "SUBSCRIBED",
        "properties.signup_source": source
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      type: 'post', 
      success: function(s) {
        if(s.ok) {
          if ( source == 'WishlistBackInStock'){
            _this.closest('.backInStock_custom__form__card').find('.backInStock_form__card__header').hide();
            _this.closest('.backInStock_custom__form__card').find('#backInStock_form__content').html("<h1 class='emsg success' style='text-align:center'>You're on the list! Keep your eyes on your inbox. If it becomes available, you'll be the first to know!</h1>");
            _this.closest('.backInStock_custom__form__card').find('#btnSubmitBIS').attr("disabled",true);
          }
        } 
      }
    }
    jQuery.ajax(settings).done(function (response) {
      console.log(response)
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    var mf = "";
    if(!window.SwymCallbacks){window.SwymCallbacks = [];}
    window.SwymCallbacks.push(function(){
      _swat.fetchWrtEventTypeET(function(products){
        var html = [];
        if (products.length > 0) { 
          for (var i=0; i<products.length; i++) {
            if (typeof products[i].vi !== undefined ) {
            var all_variant = products[i].vi;
              if (all_variant.indexOf("/") > -1) {
                var size = all_variant.split("/");
              }
            }
            var handle = products[i].du;
            var handle1 = handle.split("/");
            var v_id = products[i].epi;
            var handle_1 = handle1[4];
            html += '<form method="post" action="/cart/add" class="card" data-product="'+products[i]+'">'
            html += '<span class="rmv" aria-label="Delete" data-id="'+products[i].epi +'">X</span>';
            html += '<div class="tt"><div class="p_image"><a href='+products[i].du+'?variant='+products[i].epi+'><img src='+products[i].iu+' alt="product"></a></div>';
            html += '<div class="description">';
            //           html += '<span>'+products[i].dt+'</span>';
            html += '<span class="p_name"><span class="p_name1" data-id='+ products[i].epi +' data-du='+products[i].du+' data-empi='+products[i].empi+' data-lid='+products[i].lid+'><a href='+products[i].du+'?variant='+products[i].epi+'>Name : </span>'+ products[i].dt +'</span></a>';
            if(typeof size !== undefined ){
            html += '<span class="p_size"><span class="p_size1">Size : </span>'+size[1] +'</span>';
            }
            //html += '<span class="p_price"><span class="p_price1">Price : </span><span class="price">'+ Shopify.formatMoney(products[i].pr * 100, mf)  +'</span></span>';
            html += '</div>';
            html += '<div class="wishlist_addtocart">';
            html += '<input value='+products[i].epi+' name="id" type="hidden"/><input value="1" name="quantity" type="hidden"/><input class="button btn addtocart spo-container '+ v_id +'"  data-lable="Add To Cart" type="submit" name="add"/>'
            html += '</div>';
            html += '</div>';
            html += '</form>'
            $(".swym-delete").attr("data-lid",products[i].lid);

            var backInStockSettingsUrl = "//stevemadden.co.uk/cdn/shop/files/backinstock.json?v=158468";
            var BackInStockSettings={};
            jQuery.get(backInStockSettingsUrl,function(data_b, status){
              BackInStockSettings=data_b;
            });

            var backInStockPdPData = {
              'product': {},
              'productList': {}
            };
            backInStockPdPData.product = {
              'id': products[i].empi,
              'currentVariant': products[i].epi
            };

            $.get('/products/'+handle_1+'?view=test&variant='+v_id, function(data){
              var handle = $(data).find(".handle").val();
              var abc = $(data).find(".id").val();
              var compareprice = $(data).find(".compareprice").val();
              if($(data).find(".compareprice").length > 0){
                $('.spo-container.'+handle).closest('form').find('.description .p_price .price').prepend('<del>'+ compareprice +'</del>').addClass('has_compare');
              }
              if(abc == 'false' ){
              $('.spo-container.'+handle).val('Sold Out');
                //             $('.spo-container.'+handle).addClass('sold_out').attr('disabled','disabled');
                $('.spo-container.'+handle).addClass('sold_out').hide();
                $('.spo-container.'+handle).after('<div id="backInStockDiv"><div class="backInStock_custom__form__card"><div class="backInStock_form__card__header">Notify me if my size becomes available</div><div id="backInStock_form__content" class="backInStock_form__content"><input id="backInStockEmail'+handle+'" type="email" placeholder="Enter email address" /><p style="color:red;display:none;" id="backInStockEmailError">InvalidEmailText </p><button type="button" id="btnSubmitBIS'+handle+'"  class="button btn backInStock_subscribeBack__btn" data-id="'+handle+'">JOIN WAITLIST</button><p>By signing up, you agree to be updated on news and exclusive offers from Dolce Vita. </p></div></div></div>');
              } else {
                $('.spo-container.'+handle).val('Add To Cart');
              }
              // ABTextRun();
            });
          }

          $("body").on("click",".backInStock_subscribeBack__btn",function(){
              var sid = $(this).attr("data-id");
              var _this = $(this);
              var email = _this.closest('.card').find('input[type="email"]').val();
              var pid = _this.closest('.card').find('.p_name1').attr('data-empi');
              var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              $('.emsg').empty();	
              $('#backInStockEmailError').hide();
              if (email != "" && re.test(String(email).toLowerCase()) == true) {
                wishlistometria(email,_this,'WishlistBackInStock');
              }
              else {
                $(this).closest('.backInStock_custom__form__card').find('#backInStockEmailError').show();
              }
            });

          $("body").on("keypress",'.backInStock_form__content input',function(e) {
            if (e.which == 13) {
              $(this).closest('.backInStock_form__content').find('.backInStock_subscribeBack__btn').trigger("click");
              return false;    //<---- Add this line
            }
          });
        }

        else{
          html += '<p class="clear_msg">Wish list is empty </p>';
          $(".swym-wishlist-context-menu-content").css("display","none");
        }
        $(".wish_list").append(html);
      }, _swat.EventTypes.addToWishlist);
    });

    /* add to cart */
    $('body').on('click', '.addtocart',function(event){
      var form = $(this).closest('form').attr('data-product');
      $('.product_quickview, .overlay').removeClass('active');
      $('body').removeClass('Fixed');
      _swat.replayAddToCart(form, form.epi, function() {
        // Successfully added, open cart]
        _swat.openCartPage();
      });
    });

    /* remove from page */
    var count = 0;
    $('body').on('click', '.rmv',function(){
      if($('.rmv').length == 1){
        count = 1;
      }
      var form1 = $(this).attr('data-id');
      $(this).closest("form").remove();
      window._swat.removeFromWishList(
        {
          "epi": form1,
        },
        function(r) {
          if(count == 1){
            $(".wish_list").html('<p class="clear_msg">Wish list is cleared </p>');
            $(".swym-wishlist-context-menu-content").css("display","none");
          }
        }
      );
    });

    /* share wishlist */
    $('body').on('click', '.share',function(e){
      e.preventDefault();
      var _this = $(this);
      var noteTxt = $(".Share_note").val();
      var emailId = $(".Share_Email").val();
      var fromEmailId = $(".customer_email").attr("data-customer"); 
      $('.share-error').remove();
      // _swat.sendEmailWishList(function callback() {
        // Successfully sent
        //       $(".share_main").css("display","none");
        //       $(".share_message").css("display","block");
        // $(".share_main").html('<button class="swym-close-btn" aria-label="Close Modal">X</button><div class="share_message"><span>wishlist has been shared</span></div>');
      // }, emailId,fromEmailId, noteTxt);
      _swat.sendListViaEmail({
          toEmailId: $(".Share_Email").val(),
          fromName: $(".customer_email").attr("data-customer"),
          note: $(".Share_note").val(),
        },
        function callback(r) {
          $(".share_main").html('<button class="swym-close-btn" aria-label="Close Modal">X</button><div class="share_message"><span>wishlist has been shared</span></div>');
        },
      );
    });

    /* save wishlist */
    function successCallback(){
      $(".swym-success-icon").css("display","block");
      $("#fname").val('');
      $("#lname").val('');
      $("#email").val('');
    }
    function errorCallback(){ }
    $('body').on('click', '.Save',function(e){
      $(this).text("SAVED");
      var params = {
        fname: $("#fname").val(),
        lname: $("#lname").val(),
        email:$("#email").val()
      };
      _swat.saveShopperContext($("#email").val(), params, successCallback, errorCallback);
      wishlistometria($("#email").val(),$(this),'WishlistSignUp');
    });

    /* clear wishlist*/
    $('body').on('click', '.swym-delete',function(e){
      var lid = $(this).attr('data-lid');
      var data1 = [];
      $('.card').each(function(index, value) {
        var item = {};
        var form_obj = $(this).find(".p_name1");
        var epi = form_obj.attr("data-id"),
            du = form_obj.attr("data-du"),
            empi = form_obj.attr("data-empi");
        item.du = du;
        item.epi = epi;
        item.empi = empi;
        data1.push(item);
      });
      _swat.removeProductsFromList(lid, data1, function(resp){
        $(".wish_list").empty();
        $(".wish_list").html('<p class="clear_msg">Wish list is cleared </p>');
      }, function(xhrObject) {
      });
    });

    /* savelist and login form */
    $('body').on('click', '.Guest_Shopper',function(e){
      $(".Guest_form").css("display","flex");
      $(".overlay-wishlist").css("display","block");
      $("body").addClass("no-scroll");
    });

    $('body').on('click', '.close_model,.cancle_form,.overlay-wishlist',function(){
      $(".Guest_Shopper_form").css("display","none");
      $(".overlay-wishlist").css("display","none");
      $("body").removeClass("no-scroll");
    });

    /* customer popup*/
    $('body').on('click', '.customer_btn',function(){
      $(".customer_form").css("display","flex");
      $(".overlay-wishlist").css("display","block");
      $("body").addClass("no-scroll");
    });

    /* save share popup*/
    $('body').on('click', '.save_list',function(){
      $(".save_details").css("display","flex");
      $(".overlay-wishlist").css("display","block");
      $(".Guest_form").css("display","none");
      $("body").addClass("no-scroll");
    });

    $('body').on('click','.swym-close-btn,.overlay-wishlist',function(){
      if($(".save_details").length){
        $(".save_details").css("display","none");
      }
      if($(".share_details").length > 0){
        $(".share_details").css("display","none");
      }
      $(".overlay-wishlist").css("display","none");
      $("body").removeClass("no-scroll");
    });

    $('body').on('click', '.swym-share',function(){
      $(".share_details").css("display","flex");
      $(".overlay-wishlist").css("display","block");
      $("body").addClass("no-scroll");
    });
  });


  async function updatecart() {
    const res = await fetch("/?render_id=header-minicart");
    const text = await res.text();
    // Inert parse — no custom-element upgrades, so the fetched header doesn't leak.
    const html = new DOMParser().parseFromString(text, "text/html");
    const newcart = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newcart;
    const count = html.querySelector(".cart-count-bubble").innerHTML;
    if(document.querySelectorAll(".cart-count-bubble").length > 0) {
      document.querySelector(".cart-count-bubble").innerHTML = count;  
    } else {
      let cart_count_build = document.createElement('div');
      cart_count_build.classList.add('cart-count-bubble')
      cart_count_build.innerHTML = count
      document.querySelector("#cart-icon-bubble").appendChild(cart_count_build);
      
    }
    
  document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
}